import React from 'react';
import { Row, Col } from 'react-bootstrap';

export const UsersCardLoader = ({ loading = true }) => {
  const cardsCount = 4;
  const cards = Array.from({ length: cardsCount }, (_, index) => (
    <Col key={index} lg={3} md={4} sm={6} xs={12} className="mb-3">
      <div className="shimmer" style={{ width: '100%', height: '150px', borderRadius: '8px' }} />
    </Col>
  ));

  return (
    <>
      {loading && (
        <>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="shimmer mr-3" style={{ width: '90%', height: '40px', borderRadius: '8px' }} />
            <div className="shimmer" style={{ width: '10%', height: '40px', borderRadius: '8px' }} />
          </div>
          <Row>{cards}</Row>
        </>
      )}
    </>
  );
};
